import type { FaireProductEntity } from "../../entity_types/product";

export const p_f7nm9hs8f4: FaireProductEntity = {
  token: "p_f7nm9hs8f4",
  type: "product",
  name: "Pink Oversized Fold Over Sleeve Open Front Cardigan",
  brandToken: "b_nd6psatxbw",
  brandName: "Fleurworld",
  imageUrl:
    "https://cdn.faire.com/fastly/ee20e6b2d702aa78aa5d8cf61cd17097c3c7be6db70867c08ee2f846f4815330.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/148d441e09b264baaf4652c18ae95605374ebbaa8c4d85111c7b91267428c87a.jpeg",
    "https://cdn.faire.com/fastly/1d3cbb803e921f48b356183a1a3e9a34920d10aab139e37db3a9e196f5f61dea.jpeg",
    "https://cdn.faire.com/fastly/657955a7f93c83c67c9206adf145f18206bacd156b629cfd7c96029882838489.jpeg",
    "https://cdn.faire.com/fastly/f44b0676445ea6c61a7871d5edc2d070416570fe6ca348fdf9d50746fee698ac.jpeg",
    "https://cdn.faire.com/fastly/bc28a2c8af7904e868c6adee2dd1f1da2df210a145bc4433669689640d23f8d2.jpeg",
    "https://cdn.faire.com/fastly/20bb762d36cb12868f1e87f03d0871803dda28c1cc27d2542ba0e0e154f4ea4d.jpeg",
    "https://cdn.faire.com/fastly/7289ed672d2b9f0aeca8e0f65a3cfe8a816eeb5f4cab56580ba1f13ae29223b8.jpeg",
    "https://cdn.faire.com/fastly/80b78dfb0626d613bd8fb701e4b2fbed4aad0f4abbf1deb2bbb3e14ba01ffe44.png",
  ],
  priceDollars: 34.56,
  description:
    "\n * An ultra-soft, oversized fit cardigan for your leisure fashion. \n * Plain knit texture with a pair of subtle knitted patch pockets. \n * Features open front style with no closure, ribbed knit fold-over cuffs. \n * A pure color makes it so easy and fashionable to match any tees and pants. \n * \nWeight About: 0.76 kg (Volumetric Weight: 0.98 kg)\n\nMaterial: 65%Acrylic+35%Polyester\n",
  tags: [],
  msrpDollars: 69.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:40.300Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
